import z from 'zod';

export const PostProductLikeRequestSchema = z.object({
  goodsNo: z.coerce.string(),
  isLiked: z.boolean(),
});

// Service Request DTO
export type PostProductLikeServiceRequest = z.infer<typeof PostProductLikeRequestSchema>;

export const PostProductLikeResponseDataSchema = z.object({
  success: z.boolean(),
});

// Service Response DTO - API Layer와 동일한 타입 사용
export type PostProductLikeServiceResponse = z.infer<typeof PostProductLikeResponseDataSchema>;

export const ERROR_CODE_LIKE_UNAUTHORIZED = 'LIKE-001-001';
